/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectSubtaskCommentResponseDto } from '../../models/core-project-subtask-comment-response-dto';

export interface ProjectSubtaskCommentsControllerFindBySubtask$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The subtask ID to filter comments by.
 */
  subtaskId: string;
}

export function projectSubtaskCommentsControllerFindBySubtask(http: HttpClient, rootUrl: string, params: ProjectSubtaskCommentsControllerFindBySubtask$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectSubtaskCommentResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectSubtaskCommentsControllerFindBySubtask.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.query('subtaskId', params.subtaskId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectSubtaskCommentResponseDto>>;
    })
  );
}

projectSubtaskCommentsControllerFindBySubtask.PATH = '/o2-core/project-subtask-comments/{tenant}';
